export type SkillBundle = { title: string; ids: string[]; description: string };
export const SKILL_BUNDLES: Record<string, SkillBundle> = {
  'web-development': {
    title: 'Web Development',
    ids: ['html', 'css', 'javascript', 'react'],
    description: 'Build modern websites, apps, and digital products with core frontend skills.'
  },
  'ai-ml': {
    title: 'AI & Machine Learning',
    ids: ['python', 'ml', 'data-science'],
    description: 'Leverage AI/ML to create intelligent products, tools, and services.'
  },
  'marketing': {
    title: 'Digital Marketing',
    ids: ['seo', 'content', 'email-marketing'],
    description: 'Grow brands with SEO, content creation, and performance marketing.'
  },
  'design': {
    title: 'Design & Branding',
    ids: ['branding', 'ux', 'ui'],
    description: 'Craft compelling visual identities and user experiences.'
  },
  'no-code': {
    title: 'No-Code / Low-Code',
    ids: ['notion', 'zapier', 'webflow'],
    description: 'Launch products quickly using no-code tools and automations.'
  },
  'data-analytics': {
    title: 'Data Analytics',
    ids: ['sql', 'excel', 'tableau'],
    description: 'Turn data into insights and decisions with analytics skills.'
  },
  'ecommerce': {
    title: 'E-commerce',
    ids: ['shopify', 'woocommerce', 'product-sourcing'],
    description: 'Set up and scale online stores and productized services.'
  },
  'content-creation': {
    title: 'Content Creation',
    ids: ['copywriting', 'video', 'podcasting'],
    description: 'Create engaging content across formats to build audiences.'
  },
  'cybersecurity': {
    title: 'Cybersecurity',
    ids: ['security', 'risk', 'compliance'],
    description: 'Protect systems, data, and brands through security services.'
  },
  'devops': {
    title: 'DevOps & Automation',
    ids: ['docker', 'ci-cd', 'cloud'],
    description: 'Automate deployments, optimize infra, and enable developer velocity.'
  }
};

export const TIME: Record<string, { id: string; label: string }> = {
  'weekend': { id: 'weekend', label: 'Weekend' },
  'part-time': { id: 'part_time', label: 'Part-time' },
  'full-time': { id: 'full_time', label: 'Full-time' }
};

export const LOCATION: Record<string, { ids: string[]; label: string; scope: 'local'|'national'|'international' }> = {
  'remote': { ids: ['remote'], label: 'Remote', scope: 'international' },
  'local': { ids: ['in_person'], label: 'Local', scope: 'local' },
  'hybrid': { ids: ['hybrid'], label: 'Hybrid', scope: 'national' },
  'field': { ids: ['field'], label: 'Field-based', scope: 'national' }
};

export const canonicalFor = (skillsSlug: string, timeSlug: string, locationSlug: string) =>
  `https://explanatum.co.uk/business-ideas/${skillsSlug}/${timeSlug}/${locationSlug}`;

export const buildTitle = (skillsTitle: string, timeLabel: string, locationLabel: string) =>
  `${skillsTitle} Business Ideas • ${timeLabel} • ${locationLabel} | Explanatum`;

export const buildDescription = (skillsTitle: string, timeLabel: string, locationLabel: string) =>
  `Explore curated ${skillsTitle.toLowerCase()} business ideas for ${timeLabel.toLowerCase()} creators working ${locationLabel.toLowerCase()}. Generate tailored ideas instantly.`;
